import { TextField } from "@material-ui/core";
import axios from "axios";
import React, { useState } from "react";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { StyledInvoiceWrapper } from "../invoiceDialog/styledInvoice";
import Notification from "../notification/Notification";
import ServicesSelect from "../services/ServicesSelect";
import ExclusionNamesSelect from "./ExclusionNamesSelect";

const ExclusionCreateForm = ({ t, setFetch }) => {
  const defaultData = {
    "name": null,
    "value": null,
    "service": null
  };

  const [disabled, setDisabled] = useState(false);
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [submitData, setSubmitData] = useState(defaultData);

  const createExclusion = () => {
    setDisabled(true);

    if (!checkEmptyData()) {
      return;
    }

    let data = {
      name: submitData.name,
      value: submitData.value,
      serviceName: submitData.service
    };

    axios.post("/api/service-exclusions", data, userAuthenticationConfig()).then(response => {
      if (response.status === 201) {
        setFetch(prevState => !prevState);
        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successCreated") });
        setSubmitData(defaultData);
        setVisible(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const checkEmptyData = () => {
    let isValidData = true;

    Object.values(submitData).map(value => {
      if (!value) {
        isValidData = false;
      }
    });

    return isValidData;
  };

  const handleClose = () => {
    setSubmitData(defaultData);
    setVisible(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledInvoiceWrapper>
        <DefaultButton
          color="success"
          onClick={() => setVisible(true)}
        >
          {t("exclusions.createForm.create")}
        </DefaultButton>
        <MaterialDialog
          open={visible}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("exclusions.createForm.addExclusion")}
            </StyledDialogHead>
            <StyledDialogContent>
              <ExclusionNamesSelect
                checkedName={submitData.name}
                setCheckedName={(data) => setSubmitData({
                  ...submitData,
                  name: data
                })}
                t={t}
              />
              <ServicesSelect
                checkedService={submitData.service}
                setCheckedService={(data) => setSubmitData({
                  ...submitData,
                  service: data
                })}
                isObject={false}
                defaultOption={true}
              />
              <TextField
                id="value"
                label={t("exclusions.table.value")}
                value={submitData.value}
                onChange={(data) => setSubmitData({ ...submitData, "value": data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
              >
                {t("exclusions.createForm.cancelBtn")}
              </DefaultButton>
              <DefaultButton
                color="success"
                onClick={createExclusion}
                disabled={disabled || !checkEmptyData()}
              >
                {t("exclusions.createForm.createBtn")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledInvoiceWrapper>
    </>
  );
};

export default ExclusionCreateForm;